// FIX: temporary. If approved, we can move to global types file
export const BLUE_GRADIENT_CSS = {
  backgroundColor: "hsla(215,100%,95%,1)",
  backgroundImage: `radial-gradient(at 49% 40%, hsla(215,100%,95%,1) 0px, transparent 50%),
  radial-gradient(at 70% 24%, hsla(201,78%,79%,1) 0px, transparent 50%),
  radial-gradient(at 14% 10%, hsla(215,90%,51%,.3) 0px, transparent 50%),
  radial-gradient(at 35% 90%, hsla(215,100%,95%,1) 0px, transparent 50%),
  radial-gradient(at 35% 47%, hsla(201,79%,79%,1) 0px, transparent 50%),
  radial-gradient(at 80% 54%, hsla(216,100%,72%,1) 0px, transparent 50%)`,
};
